/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  merchandiseSubtotal: {
    id: 'OrderView.FulfillmentCard.itemMerchandiseSubtotal',
    defaultMessage: 'Item Subtotal'
  },
  merchandiseAdjustmentsTotal: {
    id: 'OrderView.FulfillmentCard.itemMerchandiseAdjustmentsTotal',
    defaultMessage: 'Item Discounts'
  },
  merchandiseTaxTotal: {
    id: 'OrderView.FulfillmentCard.itemMerchandiseTaxTotal',
    defaultMessage: 'Item Taxes'
  },
  merchandiseTotal: {
    id: 'OrderView.FulfillmentCard.itemMerchandiseTotal',
    defaultMessage: 'Item Total'
  },
  promotionsApplied: {
    id: 'OrderView.FulfillmentCard.promotionsApplied',
    defaultMessage: 'Promotions Applied'
  },
  proratedOrderAdjustments: {
    id: 'OrderView.FulfillmentCard.proratedOrderAdjustments',
    defaultMessage: 'Prorated Order Discounts'
  }
});
